export default "__VITE_ASSET__562130ea__"